import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { splitTextByLinks } from './util';
import { Link } from './styles';

/**
 * Renders text with any URLs in it turned into clickable links, matching the mobile app.
 * The text is rendered as React nodes, so post content stays escaped.
 */
const LinkifiedText = ({ text }) => {
  const segments = useMemo(() => splitTextByLinks(text), [text]);

  return (
    <>
      {segments.map(({ text: segmentText, url, index }) => (url ? (
        <Link
          key={index}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(event) => event.stopPropagation()}
        >
          {segmentText}
        </Link>
      ) : (
        <React.Fragment key={index}>{segmentText}</React.Fragment>
      )))}
    </>
  );
};

LinkifiedText.propTypes = {
  text: PropTypes.string,
};

LinkifiedText.defaultProps = {
  text: '',
};

export default LinkifiedText;
